import React from 'react';
import { observer } from 'mobx-react';
import Select from 'react-select';

export default observer(({ field }) => (
    <div className="form-field post-type-select" id={"form-select-" + field.id}>
        <div className="form-field-title">
            <label htmlFor={field.id} >
                {field.label}
            </label>
        </div>
        <div className="form-field-input" ><Select
            {...field.bind() }
            options={field.extra}
            arrowRenderer={()=>{}}
            placeholder={<span>?</span>}
            optionRenderer={(value, i) => {
                return (<div className={"post-icon icon-" + value.value}>{value.label}</div>)
            }}
            valueRenderer={(value, i) => {
                return (<div className={"post-icon icon-" + value.value}></div>)
            }}
            clearable={false}
            searchable={false}
        /></div>
    </div>
));





// WEBPACK FOOTER //
// ./src/components/forms/inputs/ReactSelectPostType.jsx